import { Columns } from '../columns';
import { H1, H2 } from '../headers';
import { VerticalLayout } from './vertical';
import styled from 'styled-components';

export const LandingPageHeader = styled.div<{ height?: number }>`
    ::before {
        position: absolute;
        top: -20px;
        content: '';
        height: 20px;
        width: 100%;
        background-color: #f1f1f1;
    }
    position: relative;
    display: flex;
    text-align: center;
    padding-top: 70px;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background-color: #f1f1f1;
    h1 {
        margin-top: 50px;
        margin-bottom: 50px;
    }
`;

export const HeaderLandingImage = styled.div<{ top?: number; marginBottom?: number }>`
    position: relative;
    top: ${(props) => (props.top ? props.top + 'px' : '20px')};
    margin-bottom: ${(props) => (props.marginBottom ? props.marginBottom + 'px' : '')};
`;

export const LandingPageLayout = styled(VerticalLayout)`
    text-align: center;
`;

export const ColumnItem = styled.div`
    border-radius: 8px;
    padding: 10px;
    background-color: white;
    z-index: 3;
    display: grid;
    grid-template-rows: auto auto;
`;

export const EmptyGrayCircle = styled.div`
    height: 120px;
    margin-bottom: 50px;
    width: 120px;
    border-radius: 100%;
    background-color: #ddd;
`;

export const ColumnGridItem = styled.div<{ marginBottom?: number }>`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: ${(props) => (props.marginBottom ? props.marginBottom + 'px' : '')};
`;

export const LandingPageTitle = styled(H1)`
    margin-top: 30px !important;
    margin-bottom: 15px !important;
    font-size: 32px;
    color: ${(props) => props.theme.app.component.pageTitle.textColor} !important;
`;

export const LandingPageSubtitle = styled.p<{ marginTop?: number }>`
    width: 80%;
    margin: auto;
    line-height: 1.6;
    margin-bottom: 50px;
    font-size: 16px;
    margin-top: ${(props) => (props.marginTop ? props.marginTop + 'px' : '')};
`;

export const AccordionTitle = styled(H1)`
    margin-bottom: 60px;
    font-size: 32px;
`;

export const OrangeLink = styled.a`
    color: ${(props) => props.theme.app.secondary};
    text-decoration: none;
    font-size: 13px;
    cursor: pointer;
`;

export const AccordionContainer = styled.div<{ marginTop?: number }>`
    margin-top: ${(props) => (props.marginTop ? props.marginTop + 'px' : '60px')};
    margin-bottom: 70px;
`;

export const ContactContainer = styled.div`
    align-items: center;
    text-align: center;
    list-style: none;
    padding: 0;
    justify-content: center;
    z-index: 2;
    font-size: 14px;
    padding: 50px;
    min-height: 250px;
    background-color: #f1f1f1;
    margin-bottom: 110px;
`;

export const ContactColumns = styled(Columns)`
    max-width: 70%;
    margin: auto;
    align-items: center;
    justify-content: center;
`;

export const ContactItem = styled.div`
    display: flex;
    flex-direction: column;
    padding: 20px;
    align-items: center;
    justify-content: center;
    align-self: center;

    img {
        margin-bottom: 30px;
        height: 30px;
        width: 30px;
    }
`;

export const ContactText = styled(H2)`
    margin: 10px 0 10px 0;
`;

export const ProductDetailsTitle = styled.div`
    margin-top: 40px;
    margin-bottom: 125px;
`;

export const ColumnsProductDetailsContainer = styled(Columns)`
    width: 90%;
    margin: auto;
    margin-bottom: 170px;
`;

export const ColumnProductDetailsItem = styled.div`
    display: grid;
    grid-template-rows: 190px auto auto;
    padding: 20px;
    border: 1px solid lightgray;
    border-radius: 8px;
    max-width: 560px;
    padding-bottom: 70px;
    > div {
        margin-bottom: 10px;
    }
`;

export const ColumnProductDetailImage = styled.div<{ topConfigurator?: boolean }>`
    min-height: 320px;
    position: relative;
    top: ${(props) => (props.topConfigurator ? '-50px' : '-120px')};
    z-index: 3;
`;

export const ThreeColumnsItems = styled.div<{ marginTop?: number; marginBottom?: number; top?: number }>`
    margin-top: ${(props) => (props.marginTop ? props.marginTop + 'px' : '110px')};
    margin-bottom: ${(props) => (props.marginBottom ? props.marginBottom + 'px' : '')};
    top: ${(props) => (props.top ? props.top + 'px' : '')};
`;

export const ButtonandLinkContainer = styled.div`
    padding-bottom: 50px;
    background-color: white;
`;

export const H1BigFont = styled(H1)<{ marginBottom?: number; paddingBottom?: number }>`
    font-size: 32px;
    margin-bottom: ${(props) => (props.marginBottom ? props.marginBottom + 'px' : '')};
    padding-bottom: ${(props) => (props.paddingBottom ? props.paddingBottom + 'px' : '')};
`;

export const H1ThreeColumns = styled(H1)<{ fontSize?: number }>`
    font-size: ${(props) => (props.fontSize ? props.fontSize + 'px' : '26px')};
    margin-bottom: 30px;
    color: ${(props) => props.theme.app.component.card.title.color} !important;
`;

export const ImageContainer = styled.div<{ marginBottom?: number }>`
    height: 300px;
    margin-bottom: ${(props) => (props.marginBottom ? props.marginBottom + 'px' : '120px')};
`;

export const ColumnsContainer = styled.div`
    margin-top: 60px;
`;

export const ReadGuideLinkContainer = styled.div`
    margin-top: 30px;
    margin-bottom: 30px;
`;

export const StepContainer = styled.div`
    padding: 30px;
    text-align: center;
`;

export const StepTitleContainer = styled.div`
    text-align: center;
`;
export const TitleColumnsContainer = styled.div`
    margin-top: 60px;
    margin-bottom: 40px;
`;

export const GreyBar = styled.div`
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 160px;
    background-color: #f1f1f1;
`;

export const ThreeBlockContainer = styled.div`
    position: relative;
`;
